import { FC } from 'react'
import {
  MotivationExercise as MotivationExerciseType,
  OnResponseSubmit,
  StepResponse,
} from '../../../types/Exercise'
import styles from './MotivationExercise.module.css'
import { ResponseStatus } from '../../../common/utils/exercise'
import { useSwiperSlide } from 'swiper/react'

interface MotivationExerciseProps {
  id: number
  data: MotivationExerciseType
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const MotivationExercise: FC<MotivationExerciseProps> = ({
  id,
  data,
  onResponseSubmit,
  stepResponse,
}) => {
  const { motivation } = data
  const swiperSlide = useSwiperSlide()

  if (swiperSlide.isActive && !stepResponse) {
    onResponseSubmit(id, ResponseStatus.COMPLETE)
  }

  if (motivation instanceof Array) {
    const motivations = motivation.map((m) => <p>{m}</p>)
    return <div className={styles.motivationWrapper}>{motivations}</div>
  } else {
    const phrases = motivation.split('\n').filter((phrase) => phrase !== '')

    return (
      <div className={styles.motivationWrapper}>
        {phrases.map((phrase, index) => (
          <p key={index}>{phrase}</p>
        ))}
      </div>
    )
  }
}

export default MotivationExercise
